@let alertData = alertService.alert$ | async;
@if (alertData && alertData.options) {
    @let alert = alertData.options;
    <ng-container *transloco="let t">
        <dialog
            class="bazis-alert"
            [class]="alert.cssClass"
            #dialogAlert
        >
            <div class="bazis-alert__wrapper">
                @if (alert.icon || alert.hasCloseIcon) {
                    <bazis-toolbar>
                        @if (alert.icon) {
                            <div
                                class="bazis-alert__icon"
                                slot="start"
                            >
                                <bazis-icon
                                    slot="icon"
                                    [name]="alert.icon"
                                    size="giant"
                                ></bazis-icon>
                            </div>
                        }

                        @if (alert.hasCloseIcon) {
                            <bazis-button
                                slot="end"
                                fill="clear"
                                size="large"
                                class="bazis-alert__close"
                                (click)="dismiss()"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    name="cross"
                                ></bazis-icon>
                            </bazis-button>
                        }
                    </bazis-toolbar>
                }

                <div
                    class="bazis-alert__content"
                    part="content"
                >
                    @if (alert.headerKey) {
                        <div
                            class="bazis-alert__title"
                            [innerHTML]="t(alert.headerKey, alert.headerParams)"
                        >
                        </div>
                    }

                    @if (alert.header) {
                        <div
                            class="bazis-alert__title"
                            [innerHTML]="alert.header"
                        >
                        </div>
                    }

                    @if (alert.message) {
                        <div
                            class="bazis-alert__message"
                            [innerHTML]="alert.message"
                        ></div>
                    }

                    @if (alert.messageKey) {
                        <div
                            class="bazis-alert__message"
                            [innerHTML]="t(alert.messageKey, alert.messageParams)"
                        ></div>
                    }

                    <bazis-toolbar class="bazis-alert__buttons">
                        @for (button of alert.buttons; track $index) {
                            <bazis-button
                                [slot]="button.slot ? button.slot : 'end'"
                                [fill]="button.fillButton || 'solid'"
                                [color]="button.color || 'action'"
                                [size]="button.size || 'large'"
                                (click)="buttonClick(button)"
                            >
                                @if (button.onlyIcon) {
                                    <bazis-icon
                                        slot="icon-only"
                                        [icon]="button.onlyIcon"
                                    ></bazis-icon>
                                } @else {
                                    @if (button.iconStart) {
                                        <bazis-icon
                                            slot="start"
                                            [icon]="button.iconStart"
                                        ></bazis-icon>
                                    }
                                    @if (button.iconEnd) {
                                        <bazis-icon
                                            slot="end"
                                            [icon]="button.iconEnd"
                                        ></bazis-icon>
                                    }
                                    {{ t(button.titleKey, button.titleParams) }}
                                }
                            </bazis-button>
                        }
                    </bazis-toolbar>
                </div>
            </div>
        </dialog>
        <!-- <div
            class="bazis-backdrop"
            (click)="dismiss()"
        ></div> -->
    </ng-container>
}
